import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transportista-list',
  templateUrl: './transportista-list.component.html',
  styleUrls: ['./transportista-list.component.css']
})
export class TransportistaListComponent implements OnInit {

  public title: String;
	public dataGrid: any;

	constructor() {
		
		
		this.dataGrid = {
			keyGrid: "transportista",
			qs: "&embed=tipoidentificacion&sort=nombre",
			perPage: 10,
			endPoint: "/transportistas",
			routeEdit: "ventas/transportista-edit",
			columsDef: [
				{
					Header: "Tipo identificación",
					Field: "tipoidentificacion.descripcion",
					// Searchable: true
				},
				{
					Header: "Identificación",
					Field: "dni",
					Searchable: true
				},
				{
					Header: "Nombre",
					Field: "nombre",
					Searchable: true
				},
				{
					Header: "Placa",
					Field: "placa",
					Searchable: true
				}
			]
		};
	}

	ngOnInit() {
		//
	}

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/transportista-list/transportista-list.component.ts